<template>
	<ul class="d-pagination" v-show="pagesTotalQty > 1" style="vertical-align: middle;">
		<li v-if="!c_invalid_decrement" :class="{'disabled': c_invalid_decrement}">
			<a class="cursor-pointer" @click="decrementPage">
				<svg width="8" height="16" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M5.85645 0.848335L5.85645 1.68539C5.85645 1.74231 5.82854 1.79588 5.78278 1.82936L1.41225 5.00012L5.78278 8.17088C5.82854 8.20436 5.85645 8.25793 5.85645 8.31485L5.85645 9.15191C5.85645 9.22445 5.77386 9.26686 5.7147 9.22445L0.289481 5.28918C0.0930521 5.14633 0.0930522 4.85392 0.289481 4.71217L5.7147 0.776906C5.77386 0.733379 5.85645 0.77579 5.85645 0.848335V0.848335Z" fill="#84909B"/>
				</svg>
			</a>
		</li>
		<li v-for="link in numLinksToShow" :class="{'active': link.page === page_current, 'disabled': !link.page}" :key="link.text">
			<a class="cursor-pointer" @click="gotoPage(link)">{{link.text}}</a>
		</li>
		<li v-if="!c_invalid_increment" :class="{'disabled': c_invalid_increment}">
			<a class="cursor-pointer" @click="incrementPage">
				<svg width="8" height="16" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M0.143554 0.848334L0.143554 1.68539C0.143554 1.74231 0.171456 1.79588 0.217215 1.82936L4.58775 5.00012L0.217215 8.17088C0.171457 8.20436 0.143555 8.25793 0.143555 8.31485L0.143555 9.15191C0.143555 9.22445 0.226144 9.26686 0.285296 9.22445L5.71052 5.28918C5.90695 5.14633 5.90695 4.85391 5.71052 4.71217L0.285296 0.776906C0.226144 0.733379 0.143554 0.77579 0.143554 0.848334Z" fill="#84909B"/>
				</svg>
			</a>
		</li>
	</ul>
</template>

<script>
/**
 * Компонент пролистовки с номерами страниц и СИНХРОННЫМ получением count
 */
export default {
		name: 'PagingSync',
		props: {
			page_current: {
				type: Number,
				default: 1
			},
			page_size: {
				type: Number,
				default: 25
			},
			total_records: {
				type: Number
			}
		},
		data() {
			return {

			}
		},
		computed: {
			c_invalid_decrement: function(){
				return (this.$props.page_current-1) <= 0;
			},
			c_invalid_increment: function(){
				return this.$props.page_current >= this.pagesTotalQty;
			},
			c_page_current: {
				get: function(){
					return this.$props.page_current
				},
				set: function(v){
					this.$emit('update_current_page', v);
				}
			},
			pagesTotalQty: function(){
				return Math.ceil(this.$props.total_records / this.$props.page_size)
			},
			numLinksToShow: function(){
				var depth = 4;
				var links = [];
				if (this.pagesTotalQty > 1) {
					links.push({
						text: '1',
						page: 1
					})
				}
				//if (this.pagesTotalQty > (depth * 2) && this.page_current < (this.pagesTotalQty - depth)) {
				if (this.page_current - depth - 2 > 0) {
					links.push({
						text: '...'
					})
				}
				for (var i = -depth; i < depth; i++) {
					var page = this.$props.page_current + i;
					if (page > 1 && page < (this.pagesTotalQty)) {
						links.push({
							text: page,
							page
						})
					}
				}
				//if (this.pagesTotalQty > (depth * 2) && this.page_current < (this.pagesTotalQty - depth)) {
				if (this.page_current + depth + 2 < (this.pagesTotalQty - 1)) {
					links.push({
						text: '...'
					})
				}
				links.push({
					text: this.pagesTotalQty,
					page: this.pagesTotalQty
				})

				return links
			}
		},
		methods: {
			gotoPage: function(link){
				if (link.page) {
					this.c_page_current = link.page;
				}
			},
			decrementPage: function(){
				if (this.c_invalid_decrement === false) {
					this.c_page_current--;
				}
			},
			incrementPage: function(){
				if (this.c_invalid_increment === false) {
					this.c_page_current++;
				}
			}
		}
	}
</script>

<style scoped>
.pagination li {
	display: inline-block;
}
.pagination a {
	min-width: 4ex;
	text-align: center;
}
</style>
